var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgSalesforce = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { fill: "currentColor", d: "M7.608 4.54a2.93 2.93 0 0 1 2.105-.887c1.095 0 2.05.6 2.56 1.49a3.6 3.6 0 0 1 1.446-.302c1.976 0 3.577 1.587 3.577 3.545s-1.601 3.544-3.577 3.544q-.356 0-.704-.069a2.62 2.62 0 0 1-2.283 1.316c-.41 0-.798-.093-1.144-.259a2.99 2.99 0 0 1-2.746 1.786 2.98 2.98 0 0 1-2.8-1.919 3 3 0 0 1-.569.059c-1.53 0-2.77-1.23-2.77-2.749 0-1.017.558-1.905 1.385-2.38a3.1 3.1 0 0 1-.265-1.258c0-1.746 1.443-3.16 3.223-3.16 1.045 0 1.974.487 2.562 1.243" }) }))); };
export default SvgSalesforce;
